import React from "react";
import andeLogo from "../../images/ande-logo-white.svg";

const Footer = ({
  openImpressum,
  openAGB,
  openDatenschutz,
}: {
  openImpressum: () => void;
  openAGB: () => void;
  openDatenschutz: () => void;
}) => {
  return (
    <div className="bg-primary text-white px-6 py-8 w-full">
      <div>
        For detailed information regarding our Terms and Conditions, please
        visit our website at{" "}
        <a
          className="underline"
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.toyota.co.za"
        >
          http://www.toyota.co.za
        </a>
        .
      </div>
    </div>
  );
};

export default Footer;
